import {Component, Input, OnInit} from '@angular/core';
import {EnrollCabinet} from '../../../model/enroll-cabinet';
import {FileService} from '../../../../../shared/services/file.service';
import {EnrollEgovFile} from '../../../model/enroll-egov-file';

@Component({
  selector: 'app-enroll-egov-files',
  templateUrl: './enroll-egov-files.component.html',
  styleUrls: ['./enroll-egov-files.component.scss']
})
export class EnrollEgovFilesComponent implements OnInit {
  @Input() public data: EnrollCabinet;

  constructor(private fileService: FileService) { }

  ngOnInit() {
  }

  downloadEgovFile(egovFile: EnrollEgovFile) {
    this.fileService.getEgovFile(egovFile.fileMongoId).subscribe(data => {
      this.fileService.downloadFile(data, egovFile.fileName, '');
    });
  }

  getFieldNameByCode(code: string) {
    switch (code) {
      case 'ZAGS_doc':
        return 'Свидетельство о рождении РК/Свидетельство о рождении, полученное за пределами РК';
      case 'doc_oso':
      case 'doc_tipo':
      case 'doc_univer':
        return 'Электронная копия документа об образовании с приложением';
      case 'doc_oso_abroad':
      case 'doc_tipo_abroad':
      case 'doc_univer_abroad':
        return 'Электронная копия документа об образовании (в т.ч приложения), нотариально засвидетельствованным переводом на казахский или русский язык';
      case 'tipo_medDoc':
        return 'Медицинская справка 075-У';
      case 'doc_088u':
        return 'Электронная копия заключение медико-социальной экспертизы по форме 031-У';
      case 'rivileges_suppl_doc':
        return 'Электронная копия подтверждающего документа об инвалидности ';
      case 'privileges_suppl_doc1':
        return 'Дополнительный документ подтверждающий льготу';
      case 'privileges_suppl_doc2':
        return 'Электронная копия подтверждающего документа ребенка из семьи, в котором воспитываются четыре и более несовершеннолетних детей (многодетная семья)';
      case 'privileges_suppl_doc3':
        return 'Электронная копия подтверждающего документа, о статусах "дети - сироты и дети, оставшиеся без попечения родителей" или оставшиеся без попечения родителей до совершенолетия"';
      case 'doc_kandas':
        return 'Электронная копия подтверждающего документа о статусе  "Қандас"';
      case 'doc_kazakh':
        return 'Электронная копия подтверждающего документа о статусе  "Лица, казахской национальности, не  являющегося гражданином РК"';
      case 'pmpk_doc':
        return 'Подтверждающий документ статуса "Дети с ограниченными возможностями в развитии"';
      case 'income_noASP':
        return 'Подтверждающий документ сведения о полученных доходах (заработная плата работающих родителей или их заменяющих, доходы от предпринимательской деятельности и других видов деятельности, доходы в виде алиментов на детей и других иждивенцев)';
      case 'doc_foto_tipo':
        return 'Цифровое фото';
      case 'doc_veteran':
        return 'Электронная копия подтверждающего документа ветеранов боевых действий на территории других государств, ветеранов, приравненных по льготам к ветеранам Великой Отечественной войны';
      case 'proof_law_doc':
        return 'Электронная копия документа, потвердающего законность представителя';
      case 'doc_incomplete_family':
        return 'Электронная копия подтверждающего документа о статусе "Дети из числа неполных семей, имеющих данный статус не менее трех лет"';
      case 'disabled_family':
        return 'Электронная копия подтверждающего документа о статусе "Детей из семей, воспитывающих детей-инвалидов с детства, инвалидов І, ІІ групп", копия документа подтверждающую родственную связь';
      case 'enbek':
        return 'Участник государственной программы развития продуктивной занятости и массового предпринимательства на 2017 - 2021 годы "Еңбек"';
      default:
        return '';
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/enroll/components/enroll-cabinet/tabs/enroll-egov-files/enroll-egov-files.component.ts